module.exports = __webpack_public_path__ + "static/media/Mentorship-4.ea1a13c7.jpg";